var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-3 shadow",attrs:{"title":"Länderindizes"}},[_c('div',{staticClass:"table-scrollable"},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.countryindices,"fields":_vm.fields,"responsive":"sm"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }